import { tokens, Typography } from '@sapphire-react/core';
import { Accordion } from '@sapphire-react/lab';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Item = {
  key: string;
  text: string;
  content: ReactNode;
};

type Props = {
  items: Item[];
  hideLastDivider?: boolean;
  marginTop?: string;
  headerText?: string;
};

export function MoreInformation({
  items,
  hideLastDivider = true,
  marginTop = tokens.size.spacing2xl.value,
  headerText,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Heading
        level={5}
        marginTop={marginTop}
        marginBottom={tokens.size.spacingSm.value}
        textAlign={'center'}
      >
        {headerText ?? t('shared:moreInformation.heading')}
      </Typography.Heading>
      <Accordion
        hideLastDivider={hideLastDivider}
        marginTop={tokens.size.spacingMd.value}
        UNSAFE_style={{ mixBlendMode: 'multiply' }}
      >
        {items.map(({ key, text, content }) => (
          <Accordion.Item key={key}>
            <Accordion.Heading>{t(text)}</Accordion.Heading>
            <Accordion.Panel>{content}</Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
}
